// extracted by mini-css-extract-plugin
module.exports = {"container":"_1MeSbkX2T5XlQ68NsColze"};